
import { Component, Prop, Mixins } from 'vue-property-decorator'
import { Input } from '@/mixins'

@Component({
  components: {
  }
})

export default class InputText extends Mixins(Input) {
  // v-model used on component will bind to this value
  @Prop({ required: true })
  private readonly value!: string;

  @Prop({ default: 'text' })
  private readonly type!: 'text' | 'email' | 'tel' | 'password' | 'search' | 'url';

  @Prop({ default: 100 })
  private readonly maxLength!: number
}

